import type { Product } from '@/types/product.types';

/** Identifiant stable pour une ligne panier (produit + variante pack). */
export function cartLineKey(item: { id: number; selected_pack_id?: string | null }): string {
  return `${item.id}::${item.selected_pack_id ?? ''}`;
}

/** Prix unitaire affiché / facturé : priorité au prix stocké dans le panier (pack). */
export function getCartLineUnitPrice(item: { price?: number }, product?: Product | null): number {
  if (typeof item.price === 'number' && !Number.isNaN(item.price)) {
    return item.price;
  }
  if (product) {
    return product.reduced_price || product.price;
  }
  return 0;
}

export function getCartLineDisplayName(item: { name?: string }, product?: Product | null): string {
  const n = item.name?.trim();
  if (n) return n;
  return product?.name?.trim() || '';
}
